<template>
  <div>
    <div class="banel">
      <div style="float: left">
        <img src="../../images/logo.jpg" class="logo-size"/>
      </div>
      <div style="float: left;padding-top:14px;margin-left:10px">
        <a-input-search v-model="searchKeyword" placeholder="按关键字搜内容" @search="searchGlobal"/>
      </div>
      <div style="float: right;padding-top:20px;margin-right:30px">
        欢迎你: <b>{{username}}</b>
        &nbsp;&nbsp;&nbsp;&nbsp;
        [<a href="javascript:void(0)" @click="chgPwdForm">修改密码</a>]
        &nbsp;&nbsp;&nbsp;&nbsp;
        [<a href="javascript:void(0)" @click="bindNewUserForm">绑定账号</a>]
        &nbsp;&nbsp;&nbsp;&nbsp;
        [<a href="/">退出</a>]
      </div>
      <div style="float:right;padding-top:20px;margin-right:30px" v-for="(item) in bindedUsers">
        【<a href="javascript:void(0)" @click="showBindContent(item)">{{item}}</a>】<a style="font-size: 8px;color:gray" href="javascript:void(0)" @click="removeBind(item)">X</a>&nbsp;&nbsp;
      </div>
      <div style="clear: both"></div>
    </div>
    <div>
      <a-modal v-model="chgPwdModalVisible" title="修改密码" @ok="chgPwd">
        <div>
          <div style="margin-bottom: 16px">
            <a-input-password addon-before="旧密码：" v-model="oldPassword" />
          </div>
          <div style="margin-bottom: 16px">
            <a-input-password addon-before="新密码：" v-model="newPassword1" />
          </div>
          <div style="margin-bottom: 16px">
            <a-input-password addon-before="重复密码：" v-model="newPassword2" />
          </div>
        </div>
      </a-modal>
    </div>
    <div>
      <a-modal v-model="bindUserNameVisible" title="绑定用户" @ok="bindUser">
        <div>
          <div style="margin-bottom: 16px">
            <a-input addon-before="绑定的用户名：" v-model="bindUserName" />
          </div>
        </div>
      </a-modal>
    </div>
    <div>
      <a-modal v-model="bindUserPasswordForm" title="请输入密码" @ok="toBindUser">
        <div>
          <div><b style="font-size:20px">{{bindUserAccount}}</b></div>
          <div style="margin-bottom: 16px;margin-top: 16px">
            <a-input-password addon-before="密码：" v-model="bindUserPassword" />
          </div>
        </div>
      </a-modal>
    </div>
    <div>
      <a-drawer placement="left" :visible="searchNodeVisible" :closable="false" @close="onSearchNodeClose" title="搜索到的文章">
        <div v-for="(item) in searchNodeNames">
          <div style="font-size:14px">
            <a href="javascript:void(0)" @click="searchNameOnTree(item)">{{item.split("____")[1]}}</a>
          </div>
        </div>
      </a-drawer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";

export  default {
  "name":"TopBanel",
  data(){
    return {
      "username":"",
      token:(Vue.prototype.$global.SERVER_TOKEN==null||""==Vue.prototype.$global.SERVER_TOKEN)?this.$route.query.token:Vue.prototype.$global.SERVER_TOKEN,
      oldPassword:"",
      newPassword1:"",
      newPassword2:"",
      chgPwdModalVisible:false,
      bindUserName:"",
      bindUserNameVisible:false,
      bindUserPassword:"",
      bindUserPasswordForm:false,
      bindUserAccount:"",
      bindedUsers:[],
      userTokenMapping:{},
      searchKeyword:"",
      searchNodeVisible:false,
      searchNodeNames:[]
    }
  },
  methods:{
    searchNameOnTree(nodeName){
      this.searchNodeVisible = false;
      Vue.prototype.$bus.$emit('fillNodeNameToTreeSearch', nodeName)
    },
    searchGlobal(){
      axios.post(
        Vue.prototype.$global.SERVER_URL+'/wiki/article/search-global',
        {"keyword": this.searchKeyword},
        {headers:{token:(this.token==null?this.$route.query.token:this.token)}}
      ).then((response) => {
        let dt = response.data;
        if(dt.success){
          this.searchNodeNames = [];
          let nodes = dt.fit_nodes;
          for(var ni=0; ni<nodes.length; ni++){
            this.searchNodeNames.push(nodes[ni]['_id']+"____"+nodes[ni]['node_name']);
          }
          this.searchNodeVisible = true;
        }else{
          alert(dt.message);
        }
      }).catch(function (error) {
        alert(error);
      });
    },
    onSearchNodeClose(){
      this.searchNodeVisible = false;
    },
    showBindContent(caccount){
      // 先获取token缓存
      let cachedToken = this.userTokenMapping[caccount];
      if(cachedToken != null && cachedToken.length>0){
        window.open("https://www.hjsite.com/#/dashboard?token="+cachedToken, "_blank");
        return;
      }
      // 走输入密码流程
      this.bindUserAccount = caccount;
      this.bindUserPasswordForm = true;
    },
    toBindUser(){
      axios.post(
        Vue.prototype.$global.SERVER_URL+'/wiki/login/token/get',
        {"account": this.bindUserAccount,"password":this.bindUserPassword,"type": "2"},
        {headers:{}}
      ).then((response) => {
        var dt = response.data;
        this.bindUserPassword = ""
        if(dt.success){
          this.bindUserPasswordForm = false;
          this.userTokenMapping[this.bindUserAccount] = dt.token;
          window.open("https://www.hjsite.com/#/dashboard?token="+dt.token, "_blank");
        }else{
          alert(dt.message);
        }
      }).catch(function (error) {
        alert(error);
      });
    },
    removeBind(caccount){
      if(!confirm('确定解除这个绑定？')) return;
      axios.post(
        Vue.prototype.$global.SERVER_URL+'/wiki/login/remove_bind_user',
        {"caccount": caccount},
        {headers:{token:(this.token==null?this.$route.query.token:this.token)}}
      ).then((response) => {
        var dt = response.data;
        if(dt.success){
          alert(dt.msg);
          this.refreshBindedUser()
        }else{
          alert(dt.message);
        }
      }).catch(function (error) {
        alert(error);
      });
    },
    refreshBindedUser(){
      axios.post(
        Vue.prototype.$global.SERVER_URL+'/wiki/login/list_bind_user',
        {},
        {headers:{token:(this.token==null?this.$route.query.token:this.token)}}
      ).then((response) => {
        var dt = response.data;
        if(dt.success){
          this.bindedUsers = dt.bind_user;
        }else{
          alert(dt.message);
        }
      }).catch(function (error) {
        alert(error);
      });
    },
    chgPwdForm(){
      this.chgPwdModalVisible=true
      this.oldPassword="";
      this.newPassword1="";
      this.newPassword2="";
    },
    bindNewUserForm(){
      this.bindUserNameVisible=true
      this.bindUserName="";
    },
    bindUser(){
      axios.post(
        Vue.prototype.$global.SERVER_URL+'/wiki/login/bind_new_user',
        {"caccount":this.bindUserName},
        {headers:{token:(this.token==null?this.$route.query.token:this.token)}}
      ).then((response) => {
        var dt = response.data;
        if(dt.success){
          alert(dt.msg);
          this.bindNewUserForm();
          this.bindUserNameVisible = false;
          this.refreshBindedUser();
        }else{
          alert(dt.message);
        }
      }).catch(function (error) {
        alert(error);
      });
    },
    chgPwd(){
      if(this.newPassword1 != this.newPassword2){
        alert("两次密码不一致");
        return;
      }
      axios.post(
        Vue.prototype.$global.SERVER_URL+'/wiki/login/chgpwd',
        {"oldpass":this.oldPassword, "newpass":this.newPassword1},
        {headers:{token:(this.token==null?this.$route.query.token:this.token)}}
      ).then((response) => {
        var dt = response.data;
        if(dt.success){
          alert(dt.msg);
          this.chgPwdForm();
          this.chgPwdModalVisible = false;
        }else{
          alert(dt.message);
        }
      }).catch(function (error) {
        alert(error);
      });
    },
    findUserName(){
      // 寻找用户信息
      axios.post(
        Vue.prototype.$global.SERVER_URL+'/wiki/login/token/user-info',
        {},
        {headers:{token:(this.token==null?this.$route.query.token:this.token)}}
      ).then((response) => {
        var dt = response.data;
        if(dt.success){
          this.username = dt.user.username;
        }else{
          alert(dt.message);
        }
      }).catch(function (error) {
        alert(error);
      });
      // 寻找关联账户
      this.refreshBindedUser();
    }
  },
  mounted: function(){
    window.setTimeout(this.findUserName(), 500);
  }
}

</script>

<style>
  .banel{
    border-bottom: 1px solid gray;
    height:60px;
    overflow: hidden;
  }
  .logo-size{
    width:200px;
    height:55px;
  }
</style>



// WEBPACK FOOTER //
// src/components/personal/TopBanel.vue